// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"fd0616b1","703":"dd222d96"}[chunkId] + ".chunk.js";
};